import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { MOIS_FR } from "@/lib/api";

const shade = (t) => (t >= 80 ? "bg-emerald-600 text-white" : t >= 60 ? "bg-emerald-400 text-white" : t >= 40 ? "bg-emerald-200" : t > 0 ? "bg-emerald-50" : "text-slate-300");
const pct = (t) => `${t.toLocaleString("fr-CA", { maximumFractionDigits: 1 })} %`;

const COLONNES = ["Logement", "Mois", "N° mois", "Taux d'occupation", "Nuits réservées", "Jours dans le mois"];

const MOIS_LONG = Array.from({ length: 12 }, (_, i) => {
  const m = new Date(2000, i, 1).toLocaleString("fr-CA", { month: "long" });
  return m[0].toUpperCase() + m.slice(1);
});

const exporterOccupation = (occupation) => (t) => {
  const ordre = [...t.tBodies[0].rows].map((tr) => tr.dataset.logement);
  const parNom = Object.fromEntries(occupation.logements.map((o) => [o.logement, o]));
  const lignes = ordre.filter((n) => parNom[n]).flatMap((n) => parNom[n].mois.map((m, i) => [
    { v: n }, { v: MOIS_LONG[i] }, { v: i + 1, f: "int" }, { v: m.taux / 100, f: "pct" }, { v: m.nuits, f: "int" }, { v: m.jours, f: "int" },
  ]));
  return { colonnes: COLONNES, lignes };
};

export const OccupationPanel = ({ occupation }) => (
  <Panel title="Nuits réservées et taux d'occupation" testId="bilan-occupation-panel">
    {!occupation.logements.length ? <p className="text-sm text-slate-500">Aucune nuit réservée cette année.</p> : (
      <div className="overflow-x-auto -mx-5">
        <SmartTable id="occupation" exporter={exporterOccupation(occupation)} data-export-titre="Occupation" className="w-full text-sm min-w-[1100px]" data-testid="bilan-occupation-table">
          <thead><tr>
            <th className="py-2 px-3 text-left text-[11px] font-mono uppercase tracking-wider text-slate-500">Logement</th>
            {MOIS_FR.map((m) => <th key={m} className="py-2 px-1 text-center text-[11px] font-mono uppercase tracking-wider text-slate-500">{m}</th>)}
            <th className="py-2 px-3 text-right text-[11px] font-mono uppercase tracking-wider text-slate-500">Année</th>
          </tr></thead>
          <tbody>
            {occupation.logements.map((o) => (
              <tr key={o.logement} className="border-t border-slate-100" data-logement={o.logement} data-testid={`occupation-row-${o.logement}`}>
                <td className="py-2 px-3 font-medium whitespace-nowrap">{o.logement}</td>
                {o.mois.map((m) => (
                  <td key={m.mois} className="p-1" data-testid={`occupation-${o.logement}-${m.mois}`}>
                    <div className={`rounded px-1 py-1.5 text-center tabular leading-tight transition-transform hover:scale-105 ${shade(m.taux)}`} title={`${m.nuits} nuit(s) sur ${m.jours} jours`}>
                      <p className="text-xs font-semibold">{pct(m.taux)}</p><p className="text-[10px] opacity-80">{m.nuits} n.</p>
                    </div>
                  </td>
                ))}
                <td className="py-2 px-3 text-right tabular" data-testid={`occupation-annee-${o.logement}`}>
                  <p className="font-semibold">{pct(o.taux)}</p><p className="text-[11px] text-slate-500">{o.nuits} / {o.jours} nuits</p>
                </td>
              </tr>
            ))}
          </tbody>
        </SmartTable>
      </div>
    )}
  </Panel>
);
